import { guadeloupeCity } from '../../data/mock';
import { citySlug } from '../../lib/citySlug';

export const CitySeoIndex = () => (
<div className="seo-index bg-gradient-to-br from-red-900/30 to-red-950/30 p-8 md:p-10 rounded-2xl border-2 border-red-600/40 mb-8">
              <h3 className="text-2xl md:text-3xl font-bold text-yellow-400 mb-8 text-center">
                Mots-Clés SEO Toutes les Villes : Marabout Africain Guadeloupe - Retour Affectif Rapide
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {guadeloupeCity.map((city) => (
                  <div key={citySlug(city)} className="bg-black/60 p-4 rounded-lg border border-red-900/40">
                    <h4 className="font-bold text-red-400 mb-3 text-sm border-b border-red-900/40 pb-2">{city}</h4>
                    <ul className="space-y-1.5 text-gray-300 text-xs leading-relaxed">
                      <li>• <strong className="text-yellow-400">Marabout Africain {city}</strong></li>
                      <li>• Retour Affectif Rapide {city}</li>
                      <li>• Sorcier Vaudou Haïtien {city}</li>
                      <li>• Voyant Médium Sérieux {city}</li>
                      <li>• Marabout Sérieux Retour Ex {city}</li>
                      <li>• Rituel Amour Puissant {city}</li>
                      <li>• Magie Blanche Rouge Noire {city}</li>
                      <li>• Désenvoûtement Efficace {city}</li>
                      <li>• Récupérer son Ex {city}</li>
                      <li>• Voyance Sérieuse {city}</li>
                      <li>• Marabout Traditionaliste {city}</li>
                      <li>• Grand Marabout Africain {city}</li>
                      <li>• Retour Amoureux Rapide {city}</li>
                      <li>• Medium Africain {city}</li>
                      <li>• Guérisseur Spirituel {city}</li>
                    </ul>
                  </div>
                ))}
              </div>
            </div>
);
